<template>
  <div>
    <div
      style="margin-bottom: 28px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;"
      class="flex-wrap"
    >
    <div class="d-flex align-items-center font-weight-bold" style="font-size: 18px;">
      <router-link to="/qr-code/qr-stock" class="d-flex align-items-center text-dark mr-2">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="icon mr-2" width="1em" height="1em" viewBox="0 0 320 512">
          <path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94"></path>
        </svg>
        <span>Back</span>
      </router-link>
      <span class="text-muted mx-2">|</span>
      <router-link to="/qr-code/qr-stock" class="text-muted decoration-none mx-2">Stock QR</router-link>
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="icon mx-2 text-muted" width="1em" height="1em" viewBox="0 0 320 512">
        <path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256L34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941"></path>
      </svg>
      <span class="text-dark">{{ code || '-' }}</span>
    </div>
    </div>

    <div class="bg-white rounded shadow-sm" style="padding: 20px; font-size: 14px;">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap: 16px;">
          <div>
            <h6 class="mb-0" style="color: #2F2F2F">Dealer Tujuan</h6>
          </div>
          <div style="flex: 1; min-width: 250px;">
            <Multiselect
              v-model="selectedDealer"
              :options="dealerData.map(x => x.code)"
              :custom-label="opt => (dealerData.find(x => x.code == opt).name)"
              placeholder="Select Dealer"
              :disabled="true"
            ></Multiselect>
          </div>
        </div>
        <div>
          <div>No Package</div>
          <div style="font-weight: 700;">{{ code || '-' }}</div>
        </div>
      </div>

      <div v-if="selectedDealer" class="mt-4">
        <div class="w-100 overflow-auto" style="max-height: 420px;">
          <table class="table w-100 qtrust-table">
            <thead>
              <tr>
                <th style="width: 60px;">
                  <input
                    type="checkbox"
                    :checked="isAllSelected"
                    @change="toggleSelectAll($event)"
                  />
                </th>
                <th>Serial Number</th>
                <th>QR Code</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="3">Loading...</td>
              </tr>
              <tr v-else-if="!rows.length">
                <td colspan="3">No data</td>
              </tr>
              <tr v-else v-for="(row, idx) in rows" :key="'edit-' + idx">
                <td>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="getRowKey(row, idx)"
                  />
                </td>
                <td>{{ row.serial_number || '-' }}</td>
                <td>{{ row.qrcode || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button
            class="btn mpm-button"
            type="button"
            :disabled="selected.length <= 0"
            @click="openModal"
          >
            Update
          </button>
        </div>
      </div>
    </div>

    <modal
      v-if="modalOpen"
      box-class="col-11 col-md-8 col-lg-6"
      :box-style="{
        background: 'white',
        margin: '0 auto',
        'border-radius': '8px',
        overflow: 'hidden',
        'box-shadow': '0 0 10px 0 rgba(0, 0, 0, 0.1)',
        padding: '16px 20px',
      }"
      @closeModal="closeModal"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <img src="@/assets/img/svg/arrow-left.svg" alt="Arrow Left" style="width: 24px; height: 24px; margin-right: 12px;" 
            @click="closeModal" />
          <h5 class="mb-0">Konfirmasi Update Pengiriman</h5>
        </div>
        <button class="btn" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="mt-4"> 
        <div class="row">
          <div class="col-4">
            <h6 class="mb-0" style="color: #2F2F2F">Dealer Tujuan</h6>
          </div>
          <div class="col-8">
            <p class="mb-0">Dealer {{ selectedDealer }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <h6 class="mb-0" style="color: #2F2F2F">No Package</h6>
          </div>
          <div class="col-8">
            <p class="mb-0">{{ code || '-' }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <h6 class="mb-0" style="color: #2F2F2F">Jumlah QR</h6>
          </div>
          <div class="col-8">
            <p class="mb-0">{{ selected.length }}</p>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-4">
            <h6 class="mb-0" style="color: #2F2F2F">Tanda Tangan</h6>
          </div>
          <div class="col-8" style="border: 1px solid #e5e7eb; border-radius: 6px; position: relative;">
            <vue-signature-pad width="100%" height="140px" ref="signaturePad" />
            <button
              class="btn"
              style="position: absolute; bottom: 8px; right: 8px; color: #ADADAD; border-radius: 4px; padding: 4px 12px"
              @click="$refs.signaturePad.clearSignature()"
            >
              Hapus
            </button>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button class="btn" style="color: #F36F21; width: 100px" @click="closeModal">
            Batal
          </button>
          <button class="btn" style="background: #F36F21; color:white; width: 100px; margin-left: 20px" @click="confirmUpdate">
            Update
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Modal from "@/components/modal.vue";

export default {
  metaInfo: {
    title: "Edit QR Stock",
  },
  components: {
    Multiselect,
    Modal,
  },
  data() {
    return {
      selectedDealer: "",
      dealerData: this.$store.state.filterOptions.dealer,
      rows: [],
      loading: false,
      selected: [],
      modalOpen: false,
      isSubmitting: false,
      issueData: null,
    };
  },
  computed: {
    code() {
      return this.$route && this.$route.params
        ? this.$route.params.code
        : "";
    },
    issueId() {
      return this.$route && this.$route.params
        ? this.$route.params.issueId
        : "";
    },
    isAllSelected() {
      return this.rows.length > 0 && this.selected.length === this.rows.length;
    },
  },
  beforeMount() {
    document.getElementById("content").style.background = "#F8F8F8";
  },
  beforeDestroy() {
    document.getElementById("content").style.background = "";
  },
  mounted() {
    this.fetchIssueData();
  },
  methods: {
    async fetchIssueData() {
      if (!this.issueId) return;
      try {
        const resp = await this.$http.get(`/api/qrs/issue/${this.issueId}`);
        this.issueData = resp && resp.data ? resp.data.data : null;
        if (this.issueData) {
          this.selectedDealer = this.issueData.kode_dealer || "";
          await this.fetchTabData();
        }
      } catch (err) {
        console.log(err);
        this.$swal.fire({
          title: "Error",
          text: "Gagal mengambil data issue",
          icon: "error",
        });
      }
    },
    fetchTabData() {
      if (!this.selectedDealer || !this.code) return;
      const packageCode = this.code;
      this.loading = true;
      this.$http
        .get(`/api/qrs/package/${packageCode}/?limit=500&unmapped=1`)
        .then((resp) => {
          const payload = resp && resp.data ? resp.data.data || resp.data : [];
          const rows = Array.isArray(payload)
            ? payload
            : payload && payload.rows
            ? payload.rows
            : [];
          this.rows = rows;
        })
        .catch((err) => {
          console.log(err);
          this.rows = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isAllSelected() {
      return this.rows.length > 0 && this.selected.length === this.rows.length;
    },
    toggleSelectAll(event) {
      if (event.target.checked) {
        this.selected = this.rows.map((row, idx) => this.getRowKey(row, idx));
      } else {
        this.selected = [];
      }
    },
    getRowKey(row, idx) {
      return row.qrcode || row.serial_number || idx;
    },
    openModal() {
      if (this.selected.length <= 0) return;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
    confirmUpdate() {
      if (this.isSubmitting) return;
      const qty = this.selected.length || 0;

      if (!this.$refs.signaturePad) {
        this.$swal.fire({
          title: "Error",
          text: "Tanda tangan wajib diisi",
          icon: "error",
        });
        return;
      }

      this.$swal.fire({
        title: "",
        html: `<div class="top-title">Konfirmasi Update Pengiriman QR</div>Anda akan update ${qty} QR ke Dealer ${this.selectedDealer}<br>Apa Anda yakin sudah benar?`,
        imageUrl: "/icon/icon-danger.png",
        imageWidth: 80,
        imageHeight: 80,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Ya, Update",
        cancelButtonText: "Batal",
        reverseButtons: true,
        customClass: {
          popup: 'swal2-popup-confirm',
          cancelButton: 'swal-btn-cancel',
          confirmButton: 'swal-btn-confirm'
        }
      }).then((res) => {
        const isConfirmed = res && (res.isConfirmed || res.value === true);
        if (!isConfirmed) return;

        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if (isEmpty) {
          this.$swal.fire({
            title: "Error",
            text: "Tanda tangan wajib diisi",
            icon: "error",
          });
          return;
        }

        this.processUpdate(data);
      });
    },
    processUpdate(dataSign) {
      this.isSubmitting = true;
      const serialNumbers = this.rows
        .filter((row, idx) => this.selected.includes(this.getRowKey(row, idx)))
        .map((row) => row.serial_number)
        .filter((val) => !!val);

      this.$http
        .put(`/api/qrs/issue/${this.issueId}`, {
          kode_dealer: this.selectedDealer,
          package: this.code,
          serial_number: serialNumbers,
          sender_signature: dataSign.split(",")[1],
        })
        .then(() => {
          this.$swal.fire({
            title: "Success",
            text: "Pengiriman berhasil diupdate.",
            icon: "success",
          });
          this.closeModal();
          this.$router.push('/qr-code/qr-stock');
        })
        .catch((err) => {
          const message = err && err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : "An error occurred";
          this.$swal.fire({
            title: "Error",
            text: message,
            icon: "error",
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>

<style>
.swal2-popup-confirm .swal-btn-cancel {
  background: #ffffff !important;
  color: #F36F21 !important;
  border: 1px solid #ffffff !important;
}
.swal2-popup-confirm .swal-btn-confirm {
  background: #F36F21 !important;
  color: #ffffff !important;
  border: 1px solid #F36F21 !important;
}
.swal2-popup-confirm .top-title {
  font-weight: 600;
  position: absolute;
  top: 12px;
}
.swal2-popup-confirm .swal2-actions {
  width: 100%;
}
.swal2-popup-confirm {
  padding-top: 48px !important;
}
.swal2-popup-confirm div:where(.swal2-container) button:where(.swal2-close) {
  position: absolute;
  top: 0;
  color: #000;
}
.swal2-popup-confirm .swal2-actions button {
  min-width: 150px !important;
}
</style>
